import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  createCurriculumSuccess,
  createCurriculumFailure,
  getCurriculumListSuccess,
  getCurriculumListFailure,
  updateCurriculumSuccess,
  updateCurriculumFailure,
  updateStatusCurriculumFailure,
  updateStatusCurriculumSuccess,
  viewCurriculumSuccess,
  viewCurriculumFailure,
  getActiveCurriculumListSuccess,
  getActiveCurriculumListFailure,
} from "../../actions";
import {
  CREATE_CURRICULUM,
  GET_ACTIVE_CURRICULUM_LIST,
  GET_CURRICULUM_LIST,
  UPDATE_CURRICULUM,
  UPDATE_STATUS_CURRICULUM,
  VIEW_CURRICULUM,
} from "../../Actions/types";
import api from "../../../helper/api";

function* createCurriculum(action) {
  try {
    const response = yield api.post(
      "/admin/curriculum/add-curriculum",
      action?.payload?.form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        createCurriculumSuccess({ createCurriculumData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(createCurriculumFailure({ createCurriculumError: e }));
  }
}

function* getCurriculumList(action) {
  try {
    const response = yield api.get("/admin/curriculum/curriculum-list");
    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(
        getCurriculumListSuccess({ getCurriculumListData: response?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getCurriculumListFailure({ getCurriculumListError: e }));
  }
}

function* getActiveCurriculumList(action) {
  try {
    const response = yield api.get("/admin/curriculum/fetch-curriculum");
    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(
        getActiveCurriculumListSuccess({ getActiveCurriculumListData: response?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getActiveCurriculumListFailure({ getActiveCurriculumListError: e }));
  }
}

function* updateCurriculum(action) {
  try {
    const response = yield api.put(
      `/admin/curriculum/edit-curriculum/${action?.payload?.form?.id}`,
      action?.payload?.form
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateCurriculumSuccess({ updateCurriculumData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateCurriculumFailure({ updateCurriculumError: e }));
  }
}

function* updateStatusCurriculum(action) {
  try {
    const response = yield api.put(
      `/admin/curriculum/change-status/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateStatusCurriculumSuccess({
          updateStatusCurriculumData: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(
      updateStatusCurriculumFailure({ updateStatusCurriculumError: e })
    );
  }
}

function* viewCurriculum(action) {
  try {
    const response = yield api.get(
      `/admin/curriculum/view-curriculum/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        viewCurriculumSuccess({ viewCurriculumData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewCurriculumFailure({ viewCurriculumError: e }));
  }
}

function* createCurriculumWatcher() {
  yield takeLatest(CREATE_CURRICULUM, createCurriculum);
}

function* getCurriculumListWatcher() {
  yield takeLatest(GET_CURRICULUM_LIST, getCurriculumList);
}
function* updateCurriculumWatcher() {
  yield takeLatest(UPDATE_CURRICULUM, updateCurriculum);
}
function* updateStatusCurriculumWatcher() {
  yield takeLatest(UPDATE_STATUS_CURRICULUM, updateStatusCurriculum);
}
function* viewCurriculumWatcher() {
  yield takeLatest(VIEW_CURRICULUM, viewCurriculum);
}
function* getActiveCurriculumListWatcher() {
  yield takeLatest(GET_ACTIVE_CURRICULUM_LIST, getActiveCurriculumList);
}

export default function* curriculumManagementSaga() {
  yield all([
    createCurriculumWatcher(),
    getCurriculumListWatcher(),
    updateCurriculumWatcher(),
    updateStatusCurriculumWatcher(),
    viewCurriculumWatcher(),
    getActiveCurriculumListWatcher(),
  ]);
}
